import { observable, computed, action } from 'mobx';

import { Card } from './Card';
import { Countable } from './CountableItem';
import * as constants from '../../../constants/constants';

class Group extends Countable {

  @observable products = [];
  repositoryId = '';
  type = '';
  name = '';
  rootStore = null;
  source = '';

  constructor({item, rootStore, shouldSyncAPI}) {
    super({item, shouldSyncAPI});
    this.creationDate = item['creationDate'];
    this.type = item.type;
    this.name = item.name;
    this.repositoryId = item.repositoryId;
    this.rootStore = rootStore;
    this.ID = this.repositoryId;
    this.source = item.source;
  }

  @computed
  get subtotal() {
    return this.products.reduce((summ, nextItem) => {
      return summ += nextItem.subtotal;
    }, 0);
  }

  @computed
  get totalQuantity() {
    return this.products.reduce((summ, nextItem) => {
      return summ += nextItem.quantity || 0;
    }, 0);
  }

  @computed
  get selectCards() {
    return this.products;
  }

  @action.bound
  addCards({products, shouldSyncAPI, showRelatedProducts = false, skipQtyValidation = false}) {
    let cardsArr = [];

    products.forEach((card) => {
      cardsArr.push(new Card({
        card,
        rootStore: this.rootStore,
        remove: this.removeCard,
        shouldSyncAPI,
        showRelatedProducts,
        skipQtyValidation
      }));
    });

    this.products.push(...cardsArr);
  }

  @action.bound
  addCard(card) {
    if (this.hasCard(card)) {
      return false;
    }

    this.products.push(new Card({
      card,
      rootStore: this.rootStore,
      remove: this.removeCard,
      shouldSyncAPI: true,
      showRelatedProducts: true
    }));

    this.rootStore.uiStore.showNotification(constants.ADD);
    return true;
  }

  hasCard = (card) => {
    return !!this.products.find(item => item.ID === card.skuID);
  };
}

export { Group };
